import Contact from "./components/Contact";
import Hero from "./components/Hero";
import Maps from "./components/Maps";
import Sidebar from "./components/Sidebar";
import { FaWhatsapp } from 'react-icons/fa'
import { Analytics } from '@vercel/analytics/react'

function App() {
  return (
    <main className="scroll-smooth">
      <Sidebar />
      <Hero />
      <Maps />
      <Contact />
      <a
        href="https://wa.me/+6283875037658"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50 animate-bounce"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="text-3xl" />
      </a>
      <Analytics />
    </main>
  );
}

export default App;
